import { render, staticRenderFns } from "./AdminBanksActivationCheckboxes.vue?vue&type=template&id=010fd9f7&scoped=true"
import script from "./AdminBanksActivationCheckboxes.vue?vue&type=script&lang=js"
export * from "./AdminBanksActivationCheckboxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010fd9f7",
  null
  
)

export default component.exports